import { FormControl, FormLabel, HStack, Switch, Text } from "@chakra-ui/react"
import { IconName } from "@pathwright/pathicons"
import Pathicon from "@pathwright/web/src/modules/pathicon/Pathicon"
import { Field, useFormikContext } from "formik"
import { ChangeEvent } from "react"

function SwitchField({
  option
}: {
  option: {
    field: string
    label: string
    icon?: IconName
  }
}) {
  const form = useFormikContext<any>()

  return (
    <FormLabel
      key={option.field}
      htmlFor={option.field}
      m={0}
      w="100%"
      cursor="pointer"
      _hover={{
        textDecoration: "none",
        bg: "blackAlpha.200",
        borderRadius: "20px"
      }}
      p={2}
    >
      <FormControl
        as={HStack}
        align="center"
        justify="space-between"
        w="100%"
        color="gray.500"
      >
        <HStack align="center">
          {!!option.icon && <Pathicon icon={option.icon} />}
          <Text fontSize="xs" my={0} fontWeight="normal">
            {option.label}
          </Text>
        </HStack>
        <Field
          as={Switch}
          name={option.field}
          id={option.field}
          colorScheme="brand"
          isChecked={form.values[option.field as keyof typeof form.values]}
          onChange={async (e: ChangeEvent<HTMLInputElement>) => {
            await form.setFieldValue(option.field, e.target.checked)
            await form.submitForm()
          }}
        />
      </FormControl>
    </FormLabel>
  )
}

export default SwitchField
